import { Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import AppShell, { SettingsGroup } from '../components/layout/AppShell';
import DesignSystem from '../designSystem';
import { VISIME_UI_LANGUAGE_KEY, VISIME_LANGUAGE_CHANGED } from '../config/apiLanguage';
import { useT } from '../i18n/useT';

export default function LanguageSettingsPage() {
  const t = useT();
  const [lang, setLang] = useState('en');

  useEffect(() => {
    setLang(localStorage.getItem(VISIME_UI_LANGUAGE_KEY) || 'en');
  }, []);

  const persist = (code: 'en' | 'de') => {
    setLang(code);
    localStorage.setItem(VISIME_UI_LANGUAGE_KEY, code);
    window.dispatchEvent(new Event(VISIME_LANGUAGE_CHANGED));
  };

  return (
    <AppShell title={t('language')} showBackButton maxWidth="sm" showCompanion={false}>
      <Typography sx={{ mb: 2, fontSize: 14, color: DesignSystem.colors.textSecondary }}>
        {t('languageHint')}
      </Typography>
      <SettingsGroup>
        <Box sx={{ p: 2.5, display: 'flex', gap: 1 }}>
          <Button
            variant={lang === 'en' ? 'contained' : 'outlined'}
            onClick={() => persist('en')}
            sx={{ textTransform: 'none', borderRadius: 999, boxShadow: 'none' }}
          >
            English
          </Button>
          <Button
            variant={lang === 'de' ? 'contained' : 'outlined'}
            onClick={() => persist('de')}
            sx={{ textTransform: 'none', borderRadius: 999, boxShadow: 'none' }}
          >
            Deutsch
          </Button>
        </Box>
      </SettingsGroup>
    </AppShell>
  );
}
